(function () {
    "use strict";

    // @ngInject
    function PeopleControllerCtor($scope, $translate, $injector, $state, $stateParams, $, $timeout, $q, moment, ContactsManager, UsersManager, Enums,
                                             GoogleAPIService, PopupMessageService, AnalyticsService, UserService, AppStates, SuggestionsService, UiPersistenceService,
                                             AbTestService, ConversationService, ModelFactory, DeviceService, ModalService, $filter, NetworkManager, NetworkService, ngToast, UIUtils) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'PeopleController';

        this.contactsTypes = {
            vendor: 'vendor',
            client: 'client',
            preferred_vendor: 'preferred_vendor'
        };

        this.ContactsManager = ContactsManager;
        this.ModelFactory = ModelFactory;
        this.GoogleAPIService = GoogleAPIService;
        this.PopupMessageService = PopupMessageService;
        this.AnalyticsService = AnalyticsService;
        this.UserService = UserService;
        this.UsersManager = UsersManager;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.$ = $;
        this.$timeout = $timeout;
        this.$q = $q;
        this.moment = moment;
        this.AppStates = AppStates;
        this.$state = $state;
        this.NUMBER_OF_CONTACTS = 5;
        this.ModalService = ModalService;
        this.NetworkService = NetworkService;
        this.showPendingConnections = false;
        this.ngToast = ngToast;
        this.UIUtils = UIUtils;
        this.SuggestionsService = SuggestionsService;
        this.UiPersistenceService = UiPersistenceService;

        // this.filter = {text: ""};

        this.contactsInPageCount = 10;
        this.contactCurrentLimit = 10000;
        this.currentConnectionCount = 0;
        this.checkedGoogle = false;
        this.isMobileSize = DeviceService.checkIfMobileSize();
        // this.filters = {};

        this.loadingContacts = true;
        this.hasMoreContacts = false;
        this.user = UsersManager.getCurrUser();
        this.isClient = this.user.isClient(); // should wait for result?
        this.isConnectedToGoogle = false;
        this.suggestedContacts = [];
        this.suggestedSearchContacts = [];
        // this.connection_requests = this.ModelFactory.newNetworkUsersCollection();

        this.isPageClients = false;
        this.isPageMyConnections = false;

        var self = this;

        this.loadingSuggestions = true;

        // var googleSuggestionsPromise = this.getGoogleContactSuggestions(5);
        // var graphDbSuggestionsPromise = this.getGraphDbContactSuggestions(5);
        //
        // $q.all([graphDbSuggestionsPromise, googleSuggestionsPromise])
        //     .then(function success(resultArray) {
        //
        //         var graphDbSuggestions = resultArray[0];
        //         graphDbSuggestions.forEach(
        //             function (suggested_connection) {
        //                 var curr_suggest = {
        //                     user: {
        //                         full_name: suggested_connection.full_name,
        //                         profile_image_url: suggested_connection.profile_image_url,
        //                         email: suggested_connection.email,
        //                         address: suggested_connection.address,
        //                         phone_number: suggested_connection.phone_number,
        //                         source: 'graph_db'
        //                     }
        //                 };
        //                 self.suggestedContacts.push(curr_suggest);
        //             }
        //         );
        //
        //         var googleSuggestions = resultArray[1];
        //         var amount_to_add = 5 - this.suggestedContacts.length;
        //         this.suggestedContacts = this.suggestedContacts.concat(googleSuggestions.slice(0, amount_to_add));
        //
        //     }.bind(this))
        //     .finally(function suggestionFinally() {
        //         this.loadingSuggestions = false;
        //     }.bind(this));

        // create an empty array of contacts, so we listen to the promise
        this.getContactsError = false;
        this.gotDataFromServer = false;
        this.page = 1;
        this.isLoadingMore = false;
        this.contacts = ModelFactory.newContactsCollection();

        this.NetworkManager = NetworkManager;
        this.connectionsPage = 1;
        this.currNetworkUser = this.NetworkManager.getNetworkCurrUser();

        this.showRatings = false;

        this.connectionsWithStatusNeedsResponse = [];
        this.filterOutContactNeedsResponse = function filterOutContactNeedsResponse(contact) {
            if (contact &&
                contact.user &&
                contact.user.network &&
                contact.user.network.connection_data &&
                contact.user.network.connection_data.connection_status === 'needs_response') {
                this.connectionsWithStatusNeedsResponse.push(contact);
                return true;
            } else {
                return false;
            }
        }.bind(this);

        this.activeContacts = function activeContacts() {
            if (this.filter === this.contactsTypes.vendor) {
                return 'Vendors';
            } else if (this.filter === this.contactsTypes.client) {
                return 'Clients';
            } else if (this.filter === this.contactsTypes.preferred_vendor) {
                return 'Preferred Vendors';
            }
        };

        this.register(this.contacts, 'success', function gotContacts(successType, respStatus, respIsComplete, totals) {
            this.hasMoreContacts = !respIsComplete;
            this.totalContactsForFilter = totals;
            this.gotDataFromServer = true;
            this.loadingContacts = false;

            this.contactsGrouped = this.groupContacts();
            this.isLoadingMore = false;
        }.bind(this));

        this.register(this.contacts, 'error', function error(message) {
            this.gotDataFromServer = true;
            this.loadingContacts = false;
            this.isLoadingMore = false;
            this.getContactsError = true;
        }.bind(this));

        // Filters handling
        // ================
        this.filter = {};


        if ($stateParams.listType === 'client') {
            this.filter.vendor_or_client = this.contactsTypes.client;
            this.isPageClients = true;
        } else {
            this.filter.vendor_or_client = this.contactsTypes.vendor;
            this.isPageMyConnections = true;
        }

        this.getContactsByfilter = function () {
            this.loadingContacts = true;
            this.gotDataFromServer = false;
            this.getContactsError = false;
            this.contacts.clear();
            this.page = 1;
            this.ContactsManager.getPeople(this.contacts, this.page, this.filter);

            this.suggestedSearchContacts.length = 0;
            this.searchInGoogleContacts(this.filter.text);
        };

        this.updateVendorClientFilter = function updateVendorClientFilter(type) {

            if (this.filter.vendor_or_client === type) {
                this.filter.vendor_or_client = "none";
            } else {
                this.filter.vendor_or_client = type;
            }

            this.getContactsByfilter();
        };

        this.updateIsPreferredFilter = function updateIsPreferredFilter() {
            this.filter.is_preferred = !this.filter.is_preferred;
            this.getContactsByfilter();
        };

        this.updateLeadFilter = function updateLeadFilter() {
            this.filter.lead = !this.filter.lead;
            this.getContactsByfilter();
        };

        this.updateArchivedFilter = function updateArchivedFilter() {
            this.filter.archived = !this.filter.archived;
            this.getContactsByfilter();
        };

        this.updateBookedFilter = function updateBookedFilter() {
            this.filter.booked = !this.filter.booked;
            this.getContactsByfilter();
        };

        this.updateWorkspacesCountFilter = function updateWorkspacesCountFilter() {
            this.filter.workspaces_count = !this.filter.workspaces_count;
            this.getContactsByfilter();
        };

        this.updateCompanyTypeFilter = function updateCompanyTypeFilter(companytype) {
            if (this.filter.company_type === companytype) {
                this.filter.company_type = "none";
            } else {
                this.filter.company_type = companytype;
            }
            this.getContactsByfilter();
        };

        // This is what we bind the search to
        this.filter.text = $stateParams.contactName || '';
        if (this.filter.text || this.filter.vendor_or_client) {
            this.getContactsByfilter();
        } else {
            this.ContactsManager.getPeople(this.contacts, this.page);
        }

        var tempSearchText = '',
            searchTimeout;

        $scope.$watch('peopleVm.filter.text', function (val) {
            if (searchTimeout) {
                $timeout.cancel(searchTimeout);
            }

            tempSearchText = val;
            searchTimeout = $timeout(function () {
                this.filter.text = tempSearchText;
                this.searchInContacts();
                this.suggestedSearchContacts.length = 0;
                this.searchInGoogleContacts(tempSearchText);
            }.bind(this), 800); // delay 800 ms
        }.bind(this));

        this.filterCards = function filterCards(contact) {
            var ret = true;

            // for (var filterIndex = 0; filterIndex < this.filter.length && ret; filterIndex++) {
            //     ret = ret && this.filter[filterIndex](contact);
            // }

            return ret;
        }.bind(this);
        
        this.resetSort = function resetSort() {
            this.filter.sortByLabel = "First Name";
            this.filter.sort_by_key = 'user.full_name';
            this.filter.order_asc = true;
        }.bind(this);
        
        this.resetSort();

        // sorting initialization   2
        // $translate('DASHBOARD.SORT._ALPHABETICAL_').then(function translateResolved(text) {
        //     this.filter.sortByLabel = text;
        //     this.filter.sort_by_key = 'user.full_name';
        //     this.filter.sort_order = false;
        //     // this.filter.sort_order = 1;
        //     this.filter.sortById = 'sort_by_name';
        //     angular.element(document.querySelector('#' + this.filter.sortById)).addClass("active"); // toggle first selection
        // }.bind(this));

        if ($stateParams.list === 'preferred') {
            this.updateFilter(this.contactsTypes.preferred_vendor);
        }

        this.conversationId = $stateParams.cid;
        if (this.conversationId) {
            ConversationService.openConversation(this.conversationId);
        }

        if ($stateParams.googleIntegrationCreated) {
            this.ModalService.openGoogleContactsModal(this.addSuggested.bind(this), 'Connect', true, true, 'contacts', 'add contact');
        }
        var onGoogleContactClicked = this.connectToAGoogleAccount.bind(this);

        this.UserService.on('syncGoogleContactClicked', onGoogleContactClicked );

        $scope.$on('$destroy', function () {
            this.UserService.off('syncGoogleContactClicked', onGoogleContactClicked);
        }.bind(this));

        this.UserService.on('addContactBtnClicked', this.addContactsManual.bind(this));

        this.togglePreferred = function togglePreferred(event, contact) {
            event.stopPropagation();
            event.preventDefault();

            this.ContactsManager.savePreferredVendorContact(contact, !contact.is_preferred)
            .then(function () {
                this.afterUpdateContact(contact);
            }.bind(this));
        }.bind(this);

        this.showFiltersMobile = false;

        $scope.$watchCollection('peopleVm.contacts', function () {
            this.contactsGrouped = this.groupContacts();
        }.bind(this));

        // catches emit from second level nav rebroadcast in core controller
        this.$scope.$on('broadcastContactsAdded', function(event, data) {
            this.getContactsByfilter();
        }.bind(this));

        this._shouldShowSuggestions();

        // Handle sync google clicked from +new - Add client full modal
        if ($stateParams.openSyncGoogleContacts) {
            this.connectToAGoogleAccount();
        }
    }


    Controllers.PeopleController = Class(Controllers.BaseController, {

        constructor: PeopleControllerCtor,

        afterUpdateContact: function (updatedContact) {
            if (updatedContact.isDeleted) {
                var index = this.contacts.indexOf(updatedContact);
                if (index > -1) {
                    this.contacts.splice(index, 1);
                    this.totalContactsForFilter--;
                }
            }

        },

        openGoogleContactsModal: function openGoogleContactsModal() {
            this.ModalService.openGoogleContactsModal(this.addSuggested.bind(this), 'Connect', true, true, 'contacts', 'add contact');
        },

        getNextViewedContacts: function () {
            if (!this.gotDataFromServer || !this.hasMoreContacts) {
                return;
            }
            this.isLoadingMore = true;
            this.gotDataFromServer = false;
            this.page += 1;
            this.ContactsManager.getPeople(this.contacts, this.page, this.filter);
        },

        searchInContacts: function searchInContacts() {
            var keywords = this.filter.text;
            if (keywords.length > 1) {
                this.searchedOnce = true;
                this.currentSearchTerm = this.filter.text;
                this.getContactsByfilter();
            }
            if (this.searchedOnce && keywords.length === 0) {
                this.getContactsByfilter();
                this.searchedOnce = false;
            }
        },

        searchInGoogleContacts: function searchInGoogleContacts(searchTerm) {
            if (this.user.isGoogleIntegrationActive('contacts')) {
                if (!searchTerm || searchTerm === '' || this.isFilterOn()) {
                    return;
                }

                this.UserService.searchGoogleContacts(searchTerm, null, null, true)
                    .then(function success(searchResults) {
                        this.suggestedSearchContacts = searchResults.contacts;
                    }.bind(this));
            }
        },

        connectToAGoogleAccount: function connectToAGoogleAccount(preferredGoogleAccountEmail) {
            if ( this.user.isGoogleIntegrationActive('contacts')) {
                this.openGoogleContactsModal();
            }
            else {
                this.UserService.connectToAGoogleAccount(preferredGoogleAccountEmail, 'contacts');
            }
        },

        replaceSuggested: function replaceSuggested(contact) {
            var self = this;
            var index = self.suggestedContacts.indexOf(contact);
            contact.startFade = true;
            setTimeout(function theTimeout() {
                if (index > -1) {
                    self.UserService.getNextGoogleContacts(1).then(function success(contacts) {
                        if (contacts && contacts.length > 0) {
                            self.suggestedContacts[index] = contacts[0];
                        } else {
                            self.suggestedContacts.splice(index, 1);
                        }
                    });
                }
            }, 500);
        },

        getTotalSearchResults: function getTotalSearchResults() {
            return this.totalContactsFiltered() + this.suggestedSearchContacts.length;
        },

        addContactsManual: function addContactsManual() {
            var self = this;

            var toastIcon = '<span class="icon icon-hb-nx-participants"></span>';
            var toastText = ' added successfully!';
            var toastTimeout = 1000;

            this.UserService.addContact().then(
                function contactsAdded(contact) {
                    var user = contact.user;

                    self.$timeout( function () {
                        var userNameSafeString = this.UIUtils.sanitize(user.full_name);

                        self.ngToast.create({
                            content: toastIcon + userNameSafeString + toastText,
                            className: 'success',
                            dismissOnTimeout: true,
                            dismissButton: true
                        });
                    }, toastTimeout );

                    self.contacts.push(contact);
                    this.getContactsByfilter();

                    // emit name for header nav title, via network controller broadcast
                    self.$scope.$emit('emitContactsAdded', contact);

                }.bind(this));
        },

        isFilterOn: function isFilterOn() {
            if (this.filter.sort_by_key !== 'user.full_name') {
                return true;
            } else if (this.isPageMyConnections) {
                return this.filter.preferred_vendor || this.filter.workspaces_count;
            } else if (this.isPageClients) {
                return this.filter.lead || this.filter.archived;
            } else {
                return false;
            }
        },

        suggestedVendorTypeTagClicked: function suggestedVendorTypeTagClicked(contact, type) {
            contact.user.system_user_type = type;
            this.addSuggested(contact);
        },

        addSuggested: function addSuggested(contact) {
            var self = this;

            var trackingArgs = {
                email: contact.user.email,
                type: contact.user.system_user_type,
                from: 'google'
            };

            if (this.user.isGoogleIntegrationActive('contacts')) {
                self.replaceSuggested(contact);
                index = self.suggestedSearchContacts.indexOf(contact);
                self.suggestedSearchContacts.splice(index, 1);
            } else {
                var index = self.suggestedContacts.indexOf(contact);
                self.suggestedContacts.splice(index, 1);

                index = self.suggestedSearchContacts.indexOf(contact);
                self.suggestedSearchContacts.splice(index, 1);
            }

            if (contact.user.source === 'graph_db') {
                trackingArgs.from = 'graph_db';
                trackingArgs.email = contact.user.email;
            }

            this.ContactsManager.saveJSONContact(contact).then(function success(resp) {

                contact.added = true;

                self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.save_contact, trackingArgs);

                var contactModel = resp.model;

                self.contacts.push(contactModel);

                // Kind of a HACK - we reload the specific contact to get it with the image after it was saved to S3
                self.$timeout(function () {
                    var contacts = this.ModelFactory.newContactsCollection();
                    self.ContactsManager.getPeople(contacts, 1, {text: contactModel.user.email}).then(function () {

                        if (contacts.length === 1) {
                            self.contacts.splice(self.contacts.indexOf(contactModel), 1);
                            self.contacts.push(contacts[0]);
                        }
                    }.bind(self));
                }.bind(self), 300);

            }, function error(xhr) {
                self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.save_contact_unsuccessful, trackingArgs);
                self.handleXHRError(xhr);
            });

        },

        getGraphDbContactSuggestions: function getGraphDbContactSuggestions(numOfSuggestions) {
            var defer = this.$q.defer();

            this.ContactsManager.get_graph_suggested_connection(numOfSuggestions)
                .then(function success(resp) {
                    defer.resolve(resp.data);
                })
                .catch(function failure() {
                    defer.resolve([]);
                });

            return defer.promise;
        },

        getGoogleContactSuggestions: function getGoogleContactSuggestions(numOfSuggestions) {

            var defer = this.$q.defer();

            if (this.user.isGoogleIntegrationActive('contacts')) {
                this.UserService.getNextGoogleContacts(numOfSuggestions)
                    .then(function success(contacts) {
                        defer.resolve(contacts);
                    }.bind(this))
                    .catch(function failure(resp) {
                        if (resp.data.error_type === 'HBGoogleTokenRevokedError') {
                            this.UsersManager.getGoogleIntegrations();
                        }
                        defer.resolve([]);
                    }.bind(this));
            } else {
                defer.resolve([]);
            }

            return defer.promise;
        },

        loadMoreContacts: function () {
            var leftToLoad;
            leftToLoad = this.NUMBER_OF_CONTACTS - this.suggestedContacts.length;
            if (leftToLoad > 0) {
                return this.getContacts(leftToLoad);
            }
        },

        handleXHRError: function handleXHRError(xhr) {
            var msg;
            if (xhr && xhr.responseJSON && xhr.responseJSON.error_message) {
                msg = xhr.responseJSON.error_message;
            } else {
                msg = 'DASHBOARD.CONTACTS.GOOGLE.GOOGLE_API._UNKNOWN_ERROR_';
            }
            this.isConnectedToGoogle = false;
            this.PopupMessageService.showErrorAlert(msg);
        },

        handleClickSort: function handleClickSort(sortkey, sortlabel, sortreverse) {
            this.filter.sort_by_key = sortkey;
            this.filter.sortByLabel = sortlabel;
            this.filter.order_asc = !Boolean(sortreverse);
            this.getContactsByfilter();
        },

        getContactsView: function getContactsView() {
            var contactsView = [];
            contactsView = contactsView.concat(this.suggestedSearchContacts);
            this.contacts.forEach(function (contact) {
                contactsView.push(contact);
            });
            return contactsView;
        },
        
        clearSearch: function clearSearch() {
            this.filter.text = '';
        },
        
        handleClickOpenFiltersMobile: function handleClickOpenFiltersMobile() {
            this.showFiltersMobile = true;
            angular.element('body')[0].style.overflow = 'hidden';
        },

        handleClickCloseFiltersMobile: function handleClickCloseFiltersMobile() {
            this.showFiltersMobile = false;
            angular.element('body')[0].style.overflow = 'auto';
        },
        
        resetSearchAndFilters: function resetSearchAndFilters() {
            this.filter.is_preferred = false;
            this.filter.workspaces_count = false;
            this.clearSearch();
            this.resetSort();
            this.getContactsByfilter();
        },

        showSearchAndFiltersReset: function showSearchAndFiltersReset() {
            return this.filter.text.length > 1 ||
                   this.filter.is_preferred ||
                   this.filter.workspaces_count ||
                   this.filter.sort_by_key !== 'user.full_name';
        },

        updatePendingConnectionFilter: function updatePendingConnectionFilter() {
            this.filter.pending_connections = !this.filter.pending_connections;
        },

        loadMoreRequests: function loadMoreRequests(){
            this.connectionsRequestsPage++;
            this.NetworkManager.getConnections(this.connection_requests, this.currNetworkUser._id, this.connectionsPage,true);
            this.loadingConnectionRequests = true;
        },
        
        totalContactsFiltered: function totalContactsFiltered() {
            var total = this.totalContactsForFilter;
            if (total && (total > 0)) {
                return total;
            } else {
                return 0;
            }
        },

        isLoadingConnections: function isLoadingConnections() {
            return this.loadingContacts || !this.gotDataFromServer;
        },

        groupContacts: function groupContacts() {
            var groupedContacts = {};
            var sort = this.filter.sort_by_key;
            this.connectionsWithStatusNeedsResponse = [];

            var groupLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G',
                'H', 'I', 'J', 'K', 'L', 'M', 'N',
                'O', 'P', 'Q', 'R', 'S', 'T', 'U',
                'V', 'W', 'X', 'Y', 'Z'];

            if (sort === 'user.full_name') {
                groupedContacts = {
                    // 'preferred': []
                };

                groupLetters.forEach(function(letter) {
                    groupedContacts[letter] = [];
                });

                groupedContacts['N/A (other)'] = [];

                this.contacts.forEach(function(contact) {
                    var category = '';

                    // if (contact.is_preferred) {
                    //     category = 'preferred';
                    // } else 
                    if (contact.user.full_name &&
                        contact.user.full_name.length > 0) {
                        var firstChar = contact.user.full_name.charAt(0).toUpperCase();

                        if (groupLetters.indexOf(firstChar) !== -1) {
                            category = firstChar;
                        } else {
                            category = 'N/A (other)';
                        }
                    } else {
                        category = 'N/A (other)';
                    }

                    groupedContacts[category].push(contact);
                }.bind(this));
            } else if (sort === 'created_at') {
                groupedContacts = {
                    'PAST WEEK': [],
                    'PAST MONTH': [],
                    'PAST YEAR': [],
                    'SINCE FOREVER': []
                };

                var oneWeekAgo = new Date();
                oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

                var oneMonthAgo = new Date();
                oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);

                var oneYearAgo = new Date();
                oneYearAgo.setDate(oneYearAgo.getDate() - 365);

                this.contacts.forEach(function(contact) {
                    var category = '';
                    var created_at = new Date(contact.created_at);

                    if (created_at > oneWeekAgo) {
                        category = 'PAST WEEK';
                    } else if (created_at > oneMonthAgo) {
                        category = 'PAST MONTH';
                    } else if (created_at > oneYearAgo) {
                        category = 'PAST YEAR';
                    } else {
                        category = 'SINCE FOREVER';
                    }

                    groupedContacts[category].push(contact);
                }.bind(this));
            }

            return groupedContacts;
        },

        openNetworkInviteUsers: function openNetworkInviteUsers() {

            this.NetworkService.inviteUser().then(
                function success(user){
                    var safeString = this.UIUtils.sanitize(user.full_name);

                    this.$timeout( function () {
                        this.ngToast.create({
                            content: '<span class="icon icon-hb-nx-participants"></span>' + safeString + ' added successfully!',
                            className: 'success',
                            dismissOnTimeout: true,
                            dismissButton: true
                        });
                    }.bind(this), 1000);
                    this.$scope.$emit('emitContactsAdded');
                }.bind(this));
        },

        onConnectionUpdate: function onConnectionUpdate(action) {
            this.ContactsManager.getPeople(this.contacts, this.page, this.filter);
        },

        /* Suggestions */
        _shouldShowSuggestions: function _shouldShowSuggestions() {
            this.shouldShowGoogleSyncSuggestion = false;

            if(this.user.google_integrations.length){
                return;
            }

            if (this.user.isInTrial() || this.user.companyHasSubscription()) {
                var smartSuggestionsHash = this.SuggestionsService.getSuggestionsPersistance();

                if (smartSuggestionsHash.googleSync) {
                    return;
                }

                this.shouldShowGoogleSyncSuggestion = true;
                this.GoogleSyncSuggestion = this.SuggestionsService.getSuggestion('sync_google_contacts');
            }
        },

        suggestionSyncGoogleContacts: function suggestionSyncGoogleContacts() {
            this.UserService.syncGoogleContactClicked();
        },

        suggestionViewed: function suggestionViewed() {
             var smartSuggestionsHash = this.SuggestionsService.getSuggestionsPersistance();
                 smartSuggestionsHash.googleSync = true;

            this.SuggestionsService.setSuggestionPersistance(smartSuggestionsHash);
        },

        onUploadClientsModal: function onUploadClientsModal() {
            this.ModalService.openUploadClientsModal('upload');
        },

        handleClickAddClient: function handleClickAddClient() {

            // Toast configuration
            var toastIcon = '<span class="icon icon-hb-nx-participants"></span>';
            var toastText = ' added successfully!';
            var toastTimeout = 1000;

            this.AnalyticsService.trackClick(this, 'add client');
            this.UserService.addContact().then(function(contact) {
                var user = contact.user;
                this.$timeout( function () {
                    var userNameSafeString = this.UIUtils.sanitize(user.full_name);

                    this.ngToast.create({
                        content: toastIcon + userNameSafeString + toastText,
                        className: 'success',
                        dismissOnTimeout: true,
                        dismissButton: true
                    });
                }.bind(this), toastTimeout);

                // emit name for header nav title, via network controller broadcast
                this.$scope.$emit('emitContactsAdded', contact);
            }.bind(this));
        },

        onGoogleSyncBtnClicked: function onGoogleSyncBtnClicked() {
            //analytics move here because they need to act different, sending too many args for them to match the other "add gmail integration" events that we have.
            if (this.user.isGoogleIntegrationActive('contacts')){
                this.AnalyticsService.trackClick(this, 'open google contacts', {source: "second_level_nav", type: "contacts", app_path: "second_level_nav", event: "open google contacts", eventType: "click"});
            }
            else{
                this.AnalyticsService.trackClick(this, 'add gmail integration', {source: "second_level_nav", type: "contacts", app_path: "second_level_nav", event: "add gmail integration", eventType: "click"});
            }

            this.UserService.syncGoogleContactClicked();
        }

    });
}());
